import React, { useEffect, useRef, useState } from 'react'
import style from "./DashboardSidebar.module.css";
import { useTheme } from '../../Themes/ThemeContext';
const DashboardThemes = ({ setTheme }) => {
    const [activeTheme, setActiveTheme] = useState("light");
    const [AccountModal, setAccountModal] = useState(false);
    const [accountActive, setAccountActive] = useState("");
    const [showSignoutModal, setShowSignOutModal] = useState(false);
    const { theme, toggleTheme, newavailableThemes } = useTheme();


    return (
        <div className={style.Themedropdown} >
            <ul>
                {/* <li className={style.accountoptioninactive}>
                    <button onClick={() => { setAccountActive("profile"); setAccountModal(true); }}>
                        Profile
                    </button>
                </li>
                <li className={accountActive === "signout" ? style.accountoptionactive : style.accountoptioninactive}>
                    <button onClick={() => { setAccountActive("signout"); setShowSignOutModal(true) }}>
                        Sign out
                    </button>
                </li> */}
                {newavailableThemes.map((item, index) => (
                    <ul key={index}>
                        <button onClick={() => { toggleTheme(item); setTheme(false) }}>{item.name}</button>
                    </ul>
                ))}
            </ul>
        </div>
    )
}

export default DashboardThemes
